import { createFileRoute } from '@tanstack/react-router';
import { NotFoundPage } from '@/page/NotFoundPage';

export const Route = createFileRoute('/_app/$')({ component: NotFoundPage });
